export const FragmentMarketCountry = new TypedDocumentString(`
    fragment MarketCountry on MarketCountry {
  id
  iso2
  continent
  priority
  telCode
  title {
    value
    __typename
  }
  isEu
  altname
  img {
    ...Image
    __typename
  }
  __typename
}
    fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}`, {"fragmentName":"MarketCountry"});